class QuickBuySlider extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
    this.timer = null;
    this.isPaused = false;
  }

  connectedCallback() {
    this.track = this.querySelector('.quick-buy-slider__track');
    this.slides = Array.from(this.querySelectorAll('.quick-buy-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.quick-buy-slider__dot'));
    this.prevBtn = this.querySelector('[data-direction="prev"]');
    this.nextBtn = this.querySelector('[data-direction="next"]');
    this.interval = Number(this.dataset.interval || 5) * 1000;
    this.autoRotate = this.dataset.autoRotate !== 'false' && this.slides.length > 1;

    if (!this.track || this.slides.length === 0) return;

    this.prevBtn?.addEventListener('click', () => this.go(-1, true));
    this.nextBtn?.addEventListener('click', () => this.go(1, true));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i, true)));

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.resume());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.resume();
    });

    this.update();
    if (this.autoRotate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.startTimer();
    }
  }

  disconnectedCallback() {
    this.clearTimer();
  }

  startTimer() {
    this.clearTimer();
    this.timer = window.setInterval(() => this.go(1), this.interval);
  }

  clearTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  pause() {
    this.isPaused = true;
    this.clearTimer();
  }

  resume() {
    if (!this.autoRotate) return;
    this.isPaused = false;
    this.startTimer();
  }

  go(step, manual = false) {
    const total = this.slides.length;
    this.index = (this.index + step + total) % total;
    this.update();
    if (manual && this.autoRotate && !this.isPaused) this.startTimer();
  }

  goTo(index, manual = false) {
    this.index = index;
    this.update();
    if (manual && this.autoRotate && !this.isPaused) this.startTimer();
  }

  update() {
    const offset = this.index * 100;
    this.track.style.transform = `translate3d(-${offset}%, 0, 0)`;

    this.slides.forEach((slide, i) => {
      slide.querySelector('.quick-buy-slider__card')?.classList.toggle('is-active', i === this.index);
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
  }
}

customElements.define('quick-buy-slider', QuickBuySlider);
